export const ICON_SIZE_IN_PIXEL = 16;
export const LIST_TYPE_LABEL_SIZE = 10;
